export default "__VITE_ASSET__CsrECBPW__"